import {
  CE_11,
  CATALOG_ENTRIES_DEFAULTS,
  hideCE11Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  CATALOG_HOME_LINK_TYPE,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  FILTER_OPTIONS,
  OTHER_LINK_TYPE,
  URL_TYPE_OPTIONS,
} from "constants/stores/routes";

const createGridItemProp = (itemNumber, description) => ({
  type: "object",
  fields: {
    image: {
      type: "imageUrl",
    },
    imageAlt: {
      type: "string",
    },
    linkText: {
      type: "string",
    },
    linkType: {
      type: "choice",
      options: URL_TYPE_OPTIONS,
      defaultValue: CATALOG_HOME_LINK_TYPE,
    },
    filterOptions: {
      type: "choice",
      options: FILTER_OPTIONS,
    },
    linkOpenInNewTab: {
      type: "boolean",
      defaultValue: false,
    },
    linkOtherUrl: {
      type: "string",
      defaultValue: "",
    },
    linkCategorySlug: {
      type: "string",
      defaultValue: "",
    },
  },
  defaultValue: {
    image: CATALOG_ENTRIES_DEFAULTS[CE_11][`gridItem${itemNumber}Image`],
    imageAlt: CATALOG_ENTRIES_DEFAULTS[CE_11][`gridItem${itemNumber}ImageAlt`],
    linkText: CATALOG_ENTRIES_DEFAULTS[CE_11][`gridItem${itemNumber}LinkText`],
    linkType: OTHER_LINK_TYPE,
    linkOpenInNewTab: false,
    linkOtherUrl: CATALOG_ENTRIES_DEFAULTS[CE_11][`gridItem${itemNumber}LinkUrl`] ?? "",
    linkCategorySlug: "",
  },
  description: `${description} (CE11 only)`,
  hidden: hideCE11Props,
});

export const CE11_PLASMIC_PROPS = {
  eyebrowText: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].eyebrowText,
    description: "Eyebrow text above heading (CE11 only)",
    hidden: hideCE11Props,
  },
  mainHeading: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].mainHeading,
    description: "First line of main heading (CE11 only)",
    hidden: hideCE11Props,
  },
  highlightedWord1: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].highlightedWord1,
    description: "Highlighted Word 1 - animates in heading (CE11 only)",
    hidden: hideCE11Props,
  },
  highlightedWord2: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].highlightedWord2,
    description: "Highlighted Word 2 - animates in heading (CE11 only)",
    hidden: hideCE11Props,
  },
  highlightedWord3: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].highlightedWord3,
    description: "Highlighted Word 3 - animates in heading (CE11 only)",
    hidden: hideCE11Props,
  },
  subHeading: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].subHeading,
    description: "Third line of heading (CE11 only)",
    hidden: hideCE11Props,
  },
  description: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].description,
    description: "Description text (CE11 only)",
    hidden: hideCE11Props,
  },
  ctaText: {
    type: "string",
    defaultValue: CATALOG_ENTRIES_DEFAULTS[CE_11].ctaText,
    description: "CTA button text (CE11 only)",
    hidden: hideCE11Props,
  },
  ctaLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    hidden: hideCE11Props,
  },
  ctaOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open CTA button in new tab (CE11 only)",
    hidden: hideCE11Props,
  },
  ctaOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) => hideCE11Props(props) || props.ctaLinkType !== OTHER_LINK_TYPE,
  },
  ctaCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideCE11Props(props) ||
      (props.ctaLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.ctaLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  gridItem1: createGridItemProp(1, "Grid Item 1"),
  gridItem2: createGridItemProp(2, "Grid Item 2"),
  gridItem3: createGridItemProp(3, "Grid Item 3"),
  gridItem4: createGridItemProp(4, "Grid Item 4"),
  gridItem5: createGridItemProp(5, "Grid Item 5"),
  gridItem6: createGridItemProp(6, "Grid Item 6"),
  gridItem7: createGridItemProp(7, "Grid Item 7"),
  gridItem8: createGridItemProp(8, "Grid Item 8"),
  gridItem9: createGridItemProp(9, "Grid Item 9"),
  className: {
    type: "class",
    description: "Custom CSS class name for the section wrapper",
  },
};
